export const rsp = [
  {
  id: 1,
  name: 'Vlad Grecu',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Microsoft',
  Magazin: 'Microsoft Romania',
  Oras: 'Cluj-Napoca',
  Raion: 'Management',
  Functie: 'ASM',
  Logo: 'Microsoft'
  },
  {
  id: 2,
  name: 'Bogdan Alexandru Buda',
  username: 'Bret',
  email: 'supradoza_sentiment@gmail.com',
  Retea: 'Media Galaxy',
  Magazin: 'Media Galaxy Targu Mures',
  Oras: 'Targu Mures',
  Raion: 'IT',
  Functie: 'RM',
  Logo: 'MG'
  },
  {
  id: 3,
  name: 'Calin Axinie',
  username: 'Bret',
  email: 'calin.axinie@emag.ro',
  Retea: 'eMag',
  Magazin: 'eMag Cluj',
  Oras: 'Cluj-Napoca',
  Raion: 'Management',
  Functie: 'DM adj',
  Logo: 'eMag'
  },
  {
    id: 4,
    name: 'Paul Saracut',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Altex',
  Magazin: 'Altex Iulius Cluj',
  Oras: 'Cluj-Napoca',
  Raion: 'IT',
  Functie: 'RM',
  Logo: 'Altex'
  },
  {
    id: 5,
    name: 'Marius Pop',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Media Galaxy',
  Magazin: 'Media Galaxy Vivo Cluj',
  Oras: 'Cluj-Napoca',
  Raion: 'IT',
  Functie: 'RM',
  Logo: 'Microsoft'
  },
  {
    id: 6,
    name: 'Vlad Grecu',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Altex',
  Magazin: 'Microsoft Romania',
  Oras: 'Cluj-Napoca',
  Raion: 'Management',
  Functie: 'ASM',
  Logo: 'Microsoft'
  },
  {
    id: 7,
    name: 'Vlad Grecu',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Microsoft',
  Magazin: 'Microsoft Romania',
  Oras: 'Cluj-Napoca',
  Raion: 'Management',
  Functie: 'ASM',
  Logo: 'Microsoft'
  },
  {
    id: 8,
    name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Altex',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
  },
  {
    id: 9,
    name: 'Vlad Grecu',
  username: 'Bret',
  email: 'v-vlgrec@microsoft.com',
  Retea: 'Microsoft',
  Magazin: 'Microsoft Romania',
  Oras: 'Cluj-Napoca',
  Raion: 'Management',
  Functie: 'ASM',
  Logo: 'Microsoft'
  },
  {
    id: 10,
    name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Microsoft',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
  },
  {
    id: 11,
    name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Microsoft',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
    },
    {
    id: 12,
    name: 'Bogdan Alexandru Buda',
    username: 'Bret',
    email: 'supradoza_sentiment@gmail.com',
    Retea: 'Media Galaxy',
    Magazin: 'Media Galaxy Targu Mures',
    Oras: 'Targu Mures',
    Raion: 'IT',
    Functie: 'RM',
    Logo: 'MG'
    },
    {
    id: 13,
    name: 'Calin Axinie',
    username: 'Bret',
    email: 'calin.axinie@emag.ro',
    Retea: 'eMag',
    Magazin: 'eMag Cluj',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'DM adj',
    Logo: 'eMag'
    },
    {
      id: 14,
      name: 'Paul Saracut',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Altex',
    Magazin: 'Altex Iulius Cluj',
    Oras: 'Cluj-Napoca',
    Raion: 'IT',
    Functie: 'RM',
    Logo: 'Altex'
    },
    {
      id: 15,
      name: 'Marius Pop',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Media Galaxy',
    Magazin: 'Media Galaxy Vivo Cluj',
    Oras: 'Cluj-Napoca',
    Raion: 'IT',
    Functie: 'RM',
    Logo: 'Microsoft'
    },
    {
      id: 16,
      name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Altex',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
    },
    {
      id: 17,
      name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Microsoft',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
    },
    {
      id: 18,
      name: 'Vlad Grecu',
      username: 'Bret',
      email: 'v-vlgrec@microsoft.com',
      Retea: 'Altex',
      Magazin: 'Microsoft Romania',
      Oras: 'Cluj-Napoca',
      Raion: 'Management',
      Functie: 'ASM',
      Logo: 'Microsoft'
    },
    {
      id: 19,
      name: 'Vlad Grecu',
    username: 'Bret',
    email: 'v-vlgrec@microsoft.com',
    Retea: 'Microsoft',
    Magazin: 'Microsoft Romania',
    Oras: 'Cluj-Napoca',
    Raion: 'Management',
    Functie: 'ASM',
    Logo: 'Microsoft'
    },
    {
      id: 20,
      name: 'Vlad Grecu',
      username: 'Bret',
      email: 'v-vlgrec@microsoft.com',
      Retea: 'Microsoft',
      Magazin: 'Microsoft Romania',
      Oras: 'Cluj-Napoca',
      Raion: 'Management',
      Functie: 'ASM',
      Logo: 'Microsoft'
    }
];
